import PropTypes from 'prop-types';
import React from 'react';
import Icon from 'react-fa';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { Resource } from '../../stores/ResourceStore';
import { resourceNameDisplay, iconSlugFromResourceType } from './util';

const ResourceTypeIcon = ({ resourceType }) => (
  <div className='resource-type-icon'>
    <Icon name={iconSlugFromResourceType(resourceType)} />
  </div>
);

ResourceTypeIcon.propTypes = {
  resourceType: PropTypes.string,
};

const ResourceDetail = ({ resource }) => (
  <div className='resource-detail-container'>
    <div className='resource-name'>
      {resourceNameDisplay(resource)}
    </div>
  </div>
);

ResourceDetail.propTypes = {
  resource: PropTypes.instanceOf(Resource),
};

const ResourceActionButtons = ({ enterEditMode }) => (
  <div className='credential-buttons'>
    <div className='credential-button'>
      <Button
        className='credential-edit-button'
        onClick={enterEditMode}
      >
        Edit
      </Button>
    </div>
  </div>
);

ResourceActionButtons.propTypes = {
  enterEditMode: PropTypes.func,
};

const ResourceListing = ({ addTopBorder, resource, enterEditMode }) => (
  <div className={classNames({ 'credential-listing': true, 'credential-listing-border-top': addTopBorder })}>
    <div className='credential-leftside'>
      <ResourceTypeIcon resourceType={resource.resourceType} />
      <ResourceDetail resource={resource} />
    </div>
    <ResourceActionButtons
      resource={resource}
      enterEditMode={enterEditMode}
    />
  </div>
);

ResourceListing.propTypes = {
  addTopBorder: PropTypes.bool,
  resource: PropTypes.instanceOf(Resource),
  enterEditMode: PropTypes.func,
};

export default ResourceListing;
